import {apiSlice} from './apiSlice';
import {
    AccountOrProfile,
    GetJailsParams,
    GetJailsResponse,
    JailItem,
    PutInJailParams,
    ReleaseJailParams,
} from '../../types/accountTypes';

const getModelType = (model: AccountOrProfile): string => {
    const profileModel = 'App\\Models\\Accounts\\Profile';
    const accountModel = 'App\\Models\\Accounts\\Account';
    return model === 'profile' ? profileModel : accountModel;
}

export const jailInjectedEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getJails: builder.query<JailItem[], GetJailsParams>({
            query: ({modelType, modelID, page = 1, perPage = 999}) => {
                return `/jail/records?model_type=${getModelType(modelType)}&model_id=${modelID}&page=${page}&per_page=${perPage}`;
            },
            providesTags: ['Jail'],
            transformResponse: (response: GetJailsResponse) => {
                return response.data ?? [];
            }
        }),
        handleRelease: builder.mutation<void, ReleaseJailParams>({
            query: ({jailName, modelID, modelType}) => ({
                url: `/jail/release`,
                method: 'POST',
                body: {
                    jail_name: jailName,
                    model_id: modelID,
                    model_type: getModelType(modelType),
                }
            }),
            invalidatesTags: ['Jail'],
        }),
        putInJail: builder.mutation<void, PutInJailParams>({
            query: ({jailName, startedAt, endedAt, reason, modelID, modelType}) => ({
                url: `/jail/detain`,
                method: 'POST',
                body: {
                    jail_name: jailName,
                    reason: reason,
                    model_id: modelID,
                    model_type: getModelType(modelType),
                    started_at: startedAt,
                    ended_at: endedAt ?? null,
                }
            }),
            invalidatesTags: ['Jail'],
        }),
    })
});

export const jailEndpoints = jailInjectedEndpoints.endpoints;
export const {
    useGetJailsQuery,
    useHandleReleaseMutation,
    usePutInJailMutation,
} = jailInjectedEndpoints;
